import React from "react";

function InternetExplorer() {
  return (
    <div>
      <h3
        id="enabling-microsoft-edge-location-services"
        class="intercom-align-center"
        data-post-processed="true"
      >
        <>Enabling Microsoft Edge Location Services</>
      </h3>
      <p>
        <br />
        1. Start by clicking the <b>three-dotted menu</b> located in the top
        right-hand corner of Microsoft Edge followed by <b>Settings.</b>
      </p>
      <p>
        2. Once on the settings page, click <b>Site permission</b> from the
        left-hand menu followed by <b>Location.</b>
      </p>
      <p>
        3. You can then toggle the <b>Ask before accessing (recommended)</b>{" "}
        option.
      </p>
      <p class="no-margin">
        You can also allow or block specific sites from accessing your location:
      </p>
      <ul>
        <li>Visit a website in Microsoft Edge.</li>
        <li>
          In the corner of the address bar, select the <b>Lock</b>, <b>Info</b>,
          or <b>Dangerous </b>icon and select <b>Site permissions</b>.
        </li>
        <li>
          Next to <b>Location</b>, choose to&nbsp;
          <b>Ask </b>(default), <b>Allow</b>, or <b>Block </b>from the list.
        </li>
      </ul>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
    </div>
  );
}

export default InternetExplorer;
